import { DynamicGroupRule } from 'src/constants/types';
import {
  CreateGroupRequestData,
  Group,
  GroupFormData,
  TestGroupRulesRequestData,
  UpdateGroupRequestData,
} from '../types';
import { hasEmptyRuleValue } from './rule-operators';

export function buildFormData(data?: Group): GroupFormData {
  return {
    id: data?.id || '',
    name: data?.name || '',
    description: data?.description || '',
    type: data?.type || 'custom',
    rules:
      data?.rules?.map(r => ({
        id: r.id,
        fieldName: r.fieldName,
        operator: r.operator,
        values: buildFormRuleValues(r),
      })) || [],
  };
}

export function buildCreateRequestData(data: GroupFormData): CreateGroupRequestData {
  return {
    name: data.name,
    description: data.description,
    type: data.type,
    rules:
      data?.rules?.map(r => ({
        id: r.id,
        fieldName: r.fieldName,
        operator: r.operator,
        values: buildRequestRuleValues(r),
      })) || [],
  };
}

export function buildUpdateRequestData(data: GroupFormData): UpdateGroupRequestData {
  return {
    name: data.name,
    description: data.description,
    rules:
      data?.rules?.map(r => ({
        id: r.id,
        fieldName: r.fieldName,
        operator: r.operator,
        values: buildRequestRuleValues(r),
      })) || [],
  };
}

export function buildTestRulesRequestData(rules: GroupFormData['rules']): TestGroupRulesRequestData {
  return {
    rules:
      rules?.map(r => ({
        fieldName: r.fieldName,
        operator: r.operator,
        values: buildRequestRuleValues(r),
      })) || [],
  };
}

function buildFormRuleValues(rule: DynamicGroupRule): string[] {
  if (hasEmptyRuleValue(rule.operator)) {
    return [];
  }

  if (Array.isArray(rule.values) && rule.values.length) {
    return rule.values;
  }

  return rule.value ? [rule.value] : [''];
}

function buildRequestRuleValues(rule: GroupFormData['rules'][number]): string[] {
  if (hasEmptyRuleValue(rule.operator)) {
    return [];
  }

  return Array.isArray(rule.values) ? rule.values : [];
}
